module.exports = __webpack_public_path__ + "static/media/avatar25.4ea5f67e.png";